export default __webpack_public_path__ + "static/media/Kathok-system-header.403f69a8.jpg";